import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateInfo = () => {
  const token = useAuthToken();

  const createInfo = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/meta", credentials, token);
  };

  return createInfo;
};

export const useGetInfo = () => {
  const token = useAuthToken();

  const getInfo = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/meta", null, token);
  };

  return getInfo;
};
